// extracted by mini-css-extract-plugin
module.exports = {"Block":"BlockRenderer_Block__qZOM5","In":"BlockRenderer_In__nI3Hn","viewFooter":"BlockRenderer_viewFooter__9YnOS"};